import { pages } from 'navigation/pages'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export interface ValidationResult {
  validator: string
  checks_count: number
  messages: ValidationMessage[]
  failures: ValidationMessage[]
}

export interface ValidationMessage {
  message: string
  raw?: string
}

type Props = {
  open: boolean
  onClose: () => void
  results: ValidationResult[]
  invoiceId: number
}

export const EinvoivingError: React.FC<Props> = ({ open, results, invoiceId }) => {
  if (!open) return null

  return (
    <div style={contentStyle}>
      <Link to={pages.connected.invoice.root.navigate(invoiceId)} target="_blank">
        Ouvrir la facture
      </Link>
      {results.map((validator, idx) => (
        <ValidatorBlock key={idx} validator={validator}/>
      ))}
    </div>
  )
}

const ValidatorBlock: React.FC<{ validator: ValidationResult }> = ({ validator }) => {
  const hasIssues = validator.messages.length > 0 || validator.failures.length > 0

  return (
    <section style={sectionStyle}>
      <h3>
        {hasIssues ? '⚠️' : '✅'} {validator.validator}
      </h3>

      <p style={{ opacity: 0.7 }}>{validator.checks_count} règle(s) vérifiée(s)</p>

      {validator.messages.map((msg, i) => (
        <MessageItem key={i} message={msg} />
      ))}

      {validator.failures.map((msg, i) => (
        <MessageItem key={i} message={msg} isError />
      ))}

      {!hasIssues && <p style={{ color: 'green' }}>Aucune anomalie détectée</p>}
    </section>
  )
}

const MessageItem: React.FC<{
  message: ValidationMessage
  isError?: boolean
}> = ({ message, isError }) => {
  const [showRaw, setShowRaw] = useState(false)

  return (
    <div
      style={{
        ...messageStyle,
        borderLeft: isError ? '4px solid #d32f2f' : '4px solid #ed6c02',
      }}
    >
      <p>{message.message}</p>

      {message.raw && (
        <>
          <button style={linkButtonStyle} onClick={() => setShowRaw(!showRaw)}>
            {showRaw ? 'Masquer le détail technique' : 'Afficher le détail technique'}
          </button>

          {showRaw && <pre style={rawStyle}>{message.raw}</pre>}
        </>
      )}
    </div>
  )
}

const modalStyle: React.CSSProperties = {
  background: '#fff',
  width: '100%',
  maxHeight: '100%',
  overflow: 'auto',
  borderRadius: 8,
}

const headerStyle: React.CSSProperties = {
  padding: 16,
  borderBottom: '1px solid #ddd',
  display: 'flex',
  justifyContent: 'space-between',
}

const contentStyle: React.CSSProperties = {
  padding: 16,
}

const sectionStyle: React.CSSProperties = {
  marginBottom: 24,
}

const messageStyle: React.CSSProperties = {
  background: '#fafafa',
  padding: 12,
  marginBottom: 8,
}

const rawStyle: React.CSSProperties = {
  background: '#111',
  color: '#0f0',
  padding: 8,
  overflowX: 'auto',
  fontSize: 12,
}

const linkButtonStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: '#1976d2',
  cursor: 'pointer',
  padding: 0,
}
